import { $authHost } from "./index";

export const newFile = async (formData) => {
  const { data } = await $authHost.post("/files/upload", formData);
  return data;
};
